import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Paper,
  Divider,
  CircularProgress,
  Box,
} from '@mui/material';

const HistoricalPoModal = ({ open, onClose, poData, loading }) => {
  function formatDate(dateStr) {
    if (!dateStr) return 'N/A';
    const date = new Date(dateStr);
    return isNaN(date.getTime()) ? 'Invalid Date' : date.toISOString().split('T')[0];
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitle>
        <strong>Submitted Purchase Orders</strong>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '40vh',
            }}
          >
            <CircularProgress />
            <Typography sx={{ ml: 2 }}>Loading POs…</Typography>
          </Box>
        ) : (
          poData.map((po, index) => (
            <Paper
              key={index}
              variant="outlined"
              sx={{
                p: 3,
                mb: 3,
                backgroundColor: '#f9f9f9',
                borderLeft: '4px solid #1976d2',
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {po.tranId}
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
                    Description
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    {po.memo || ''}
                  </Typography>

                  <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
                    Vendor
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    {po.entity?.refName || '—'}
                  </Typography>

                  <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
                    Work Scope
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    {po.custbody_bpc_po_work_scope?.refName || '—'}
                  </Typography>

                  <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
                    Subsidiary Name
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    {po.subsidiary?.refName || '—'}
                  </Typography>

                  <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
                    Project
                  </Typography>
                  <Typography variant="body1">{po.class?.refName || '—'}</Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
                    PO Status
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    {po.approvalStatus?.refName || '—'}
                  </Typography>

                  <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
                    Created Date
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    {formatDate(po.createdDate)}
                  </Typography>

                  <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
                    Tran Date
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    {formatDate(po.tranDate)}
                  </Typography>

                  <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
                    Created By
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    {po.custbody_created_by?.refName || '—'}
                  </Typography>

                  <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
                    Total Amount
                  </Typography>
                  <Typography variant="body1">${parseFloat(po.total || 0).toFixed(2)}</Typography>
                </Grid>
              </Grid>
            </Paper>
          ))
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HistoricalPoModal;
